// wegogolf-app/src/components/ManagerPermission/AddContactActions.js
import React, { memo } from 'react';
import { withRole } from '../../components/Common/withRole';
import { PrimaryButton, DefaultButton } from '../../components/Common/BaseButton';

const AddContactActionsContent = ({ onCancel, onSave }) => (
  <div style={{ display: 'flex', gap: '0.5rem', marginLeft: 'auto', marginTop: '0.5rem' }}>
    <DefaultButton onClick={onCancel} style={{ minWidth: 70 }}>
      Cancel
    </DefaultButton>
    <PrimaryButton onClick={onSave} style={{ minWidth: 70 }}>
      Add Contact
    </PrimaryButton>
  </div>
);

const WithRoleAddContactActions = withRole(AddContactActionsContent, { managerOnly: true });

export const ManagerOnlyAddContactActions = memo(({ onCancel, onSave, isManager, isAuthenticated }) => {
  return (
    <WithRoleAddContactActions 
      isManager={isManager}
      isAuthenticated={isAuthenticated}
      onCancel={onCancel}
      onSave={onSave}
    />
  );
});